import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessage,
    SettingState,
    TibboDataType,
    ValidationMessageType,
} from '@appblocks/codegeneration/types';
import * as micropython from './micropython';
import * as tios from './tios';

export default class HTTPServerEndpoint extends BaseFeature {
    constructor() {
        super();
        this.name = 'HTTP Endpoint';
        this.id = 'http_server_endpoint';
        this.singleInstance = false;
        this.fileLinks = [

        ];

        const settings = [
            {
                id: 'NAME',
                name: 'Name',
                settingType: SettingType.STRING,
                required: true,
                default: 'myapi',
            },
            {
                id: 'PATH',
                name: 'Endpoint Path',
                settingType: SettingType.STRING,
                required: true,
                default: 'data',
            },
            {
                id: 'FILE',
                name: 'File',
                settingType: SettingType.FILE,
                required: true,
                readonly: true,
                default: '',
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    // getFiles(): Array<string> {
    //     const PATH = this.getSettingValue('PATH');

    //     if (this.project.runtime === 'micropython') {
    //         return [];
    //     }

    //     return [
    //         `${PATH}.html`,
    //     ];
    // }

    getState(settingId: string): SettingState {
        if (this.project.runtime === 'micropython' && settingId === 'FILE') {
            return SettingState.HIDDEN;
        }
        return super.getState(settingId);
    }

    validate(): Array<ValidationMessage> {
        switch (this.project.runtime) {
            case 'micropython':
                return micropython.validate(this);
            default:
                return tios.validate(this);
        }
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'micropython':
                return micropython.getCodeBlocks(this);
            default:
                return tios.getCodeBlocks(this);
        }
    }
}
